const assetVersions = require("@take-intl/assets/versions")

          
          const _fn = () => {
    "";
  };
          function renderCreator(_swig, _filters, _utils) {
            return function anonymous(_ctx
) {
  var _imports = {};
  var _ext = _swig.extensions,
    _output = "";
_output += "<div class=\"showtimes-placeholder__container\" id=\"movie-showtimes-loading\">\n    ";
(function () {
  var __l = ((typeof _ctx.Array !== "undefined") ? _ctx.Array : ((typeof Array !== "undefined") ? Array : _fn))(3), __len = (_utils.isArray(__l) || typeof __l === "string") ? __l.length : _utils.keys(__l).length;
  if (!__l) { return; }
    var _ctx__loopcache7e9f219116cf0dfae3c940b153f866c7 = { loop: _ctx.loop, x: _ctx.x, __k: _ctx.__k };
    _ctx.loop = { first: false, index: 1, index0: 0, revindex: __len, revindex0: __len - 1, length: __len, last: false };
  _utils.each(__l, function (x, __k) {
    _ctx.x = x;
    _ctx.__k = __k;
    _ctx.loop.key = __k;
    _ctx.loop.first = (_ctx.loop.index0 === 0);
    _ctx.loop.last = (_ctx.loop.revindex0 === 0);
    _output += "\n        <div class=\"showtimes-placeholder\">\n            <div class=\"showtimes-placeholder__header showtimes-placeholder__loading\"></div>\n\n            <div class=\"showtimes-placeholder__group\">\n                <div class=\"showtimes-placeholder__title showtimes-placeholder__loading\"></div>\n                <div class=\"showtimes-placeholder__card showtimes-placeholder__loading\"></div>\n\n                <div class=\"showtimes-placeholder__btn-list\">\n                    ";
(function () {
  var __l = ((typeof _ctx.Array !== "undefined") ? _ctx.Array : ((typeof Array !== "undefined") ? Array : _fn))(4), __len = (_utils.isArray(__l) || typeof __l === "string") ? __l.length : _utils.keys(__l).length;
  if (!__l) { return; }
    var _ctx__loopcache1467edcc45edbf88023f553828e006ed = { loop: _ctx.loop, x: _ctx.x, __k: _ctx.__k };
    _ctx.loop = { first: false, index: 1, index0: 0, revindex: __len, revindex0: __len - 1, length: __len, last: false };
  _utils.each(__l, function (x, __k) {
    _ctx.x = x;
    _ctx.__k = __k;
    _ctx.loop.key = __k;
    _ctx.loop.first = (_ctx.loop.index0 === 0);
    _ctx.loop.last = (_ctx.loop.revindex0 === 0);
    _output += "\n                        <div class=\"showtimes-placeholder__btn showtimes-placeholder__loading\"></div>\n                    ";
    _ctx.loop.index += 1; _ctx.loop.index0 += 1; _ctx.loop.revindex -= 1; _ctx.loop.revindex0 -= 1;
  });
  _ctx.loop = _ctx__loopcache1467edcc45edbf88023f553828e006ed.loop;
  _ctx.x = _ctx__loopcache1467edcc45edbf88023f553828e006ed.x;
  _ctx.__k = _ctx__loopcache1467edcc45edbf88023f553828e006ed.__k;
  _ctx__loopcache1467edcc45edbf88023f553828e006ed = undefined;
})();
_output += "\n                </div>\n\n                <div class=\"showtimes-placeholder__smp-btn showtimes-placeholder__loading\"></div>\n            </div>\n        </div>\n    ";
    _ctx.loop.index += 1; _ctx.loop.index0 += 1; _ctx.loop.revindex -= 1; _ctx.loop.revindex0 -= 1;
  });
  _ctx.loop = _ctx__loopcache7e9f219116cf0dfae3c940b153f866c7.loop;
  _ctx.x = _ctx__loopcache7e9f219116cf0dfae3c940b153f866c7.x;
  _ctx.__k = _ctx__loopcache7e9f219116cf0dfae3c940b153f866c7.__k;
  _ctx__loopcache7e9f219116cf0dfae3c940b153f866c7 = undefined;
})();
_output += "\n</div>\n";

  return _output;

}
          }
          module.exports = renderCreator;
          